module.exports = __webpack_public_path__ + "img/PGR_A02_back_en.59c8b463.png";